import { trpc, TrpcRouterOutput } from "./api/v2/trpc";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";

export const useRemoteFeatureFlags = (businessId?: number | undefined) => {
  const { business } = useSellarCurrentBusiness();

  const query = trpc.featureFlag.list.useQuery(
    { businessId: businessId ?? business?.id ?? null },
    {
      //refreshes every 10 minutes
      staleTime: 1000 * 60 * 10,
    },
  );

  type FeatureFlagReturnType = TrpcRouterOutput["featureFlag"]["list"][number];

  const featureFlags = query.data?.reduce(
    (acc, curr) => {
      return {
        ...acc,
        [curr.type]: curr,
      };
    },
    {} as {
      //this needs to be string, not FeatureFlagReturnType["type"], as we don't know whether the client is cached and whether the feature flag still exists on the server
      [key: string]: FeatureFlagReturnType;
    },
  );

  return {
    isLoading: query.isLoading,
    isActive: (featureFlag: FeatureFlagReturnType["type"]) => {
      return !!featureFlags?.[featureFlag]?.active;
    },
    featureFlags,
  };
};
